import AboutSection from "./AboutSection";
import CommentSection from "./CommentSection";
import FilesSection from "./FilesSection";
import { Container, Sections, Option } from "./styles";
import { useSwitchSection } from "./utils";
//? Marker
import { HiPencilAlt } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { useStoreState } from "react-flow-renderer";
import { activateOverlayForAdd } from "../../../state/activedFlows/actions";

const MenuBar = ({ flow, jobs = [], client, accountable, ganttStatus }) => {
  const [section, setSection] = useSwitchSection("about");
  const dispatch = useDispatch();

  const flowId = useStoreState(
    (state) => state.nodes.find((item) => item.flowId)?.flowId,
  );

  const handleOpenOverlay = () => {
    dispatch(activateOverlayForAdd(flowId));
  };

  return (
    <Container>
      <Sections>
        <Option active={section.about} onClick={() => setSection("about")}>
          Sobre
        </Option>
        <Option
          active={section.comments}
          onClick={() => setSection("comments")}
        >
          Comentários
        </Option>
        <Option active={section.files} onClick={() => setSection("files")}>
          Arquivos
        </Option>
        <Option onClick={handleOpenOverlay}>
          <HiPencilAlt
            style={{
              width: "0.8rem",
              height: "0.8rem",
              verticalAlign: "middle",
            }}
          />
        </Option>
      </Sections>

      <AboutSection
        client={client}
        flow={flow}
        jobs={jobs}
        active={section.about}
        accountable={accountable}
        ganttStatus={ganttStatus}
      />
      <CommentSection flow={flow} active={section.comments} />
      <FilesSection flow={flow} active={section.files} />
    </Container>
  );
};

export default MenuBar;
